module.exports = __webpack_public_path__ + "img/mickey10.786e1519.jpg";